<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{displayName}} ({{userType}})</h5>
      <div v-if="canIEditEmployee(detailedInfo)" class="pull-right">
        <b-button v-if="section === ''" variant="outline-primary" @click="section = 'edit'"><i class="fa fa-pencil-square-o"></i>&nbsp; Edit</b-button>
      </div>
    </div>
    <div class="list-group mb-2">
      <b-nav>
        <b-nav-item @click="section = ''"           :active="section === ''"           >Preview</b-nav-item>
        <b-nav-item @click="section = 'user'"       :active="section === 'user'"       >User</b-nav-item>
        <b-nav-item @click="section = 'additional'" :active="section === 'additional'" >Additional Data</b-nav-item>
      </b-nav>
    </div>
    <router-view></router-view>
  </b-card>
</template>
<script>
import employeeMixin from '@/mixins/employee';
import { isUndefined } from 'lodash';

export default {
  name: 'employee_detail',
  mixins: [employeeMixin],
  data() {
    const routes = this.$route.fullPath.split('/');
    return {
      section: routes[4] || '',
      loaded: false,
    };
  },
  created() {
    const { employeeId } = this.$route.params;
    this.$store.commit('employees/SET_DETAIL_ID', employeeId);
    this.$store.commit('SET_BREADCRUMB_ITEMS', [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'employees', name: 'Employees' },
      { to: employeeId, name: 'Detail' },
    ]);
  },
  computed: {
    detailedInfo() {
      return this.$store.getters['employees/get_detail_data'];
    },
    displayName() {
      return this.detailedInfo.name;
    },
    userType() {
      const { type } = this.detailedInfo;
      switch (type) {
        case 'DEFAULT':
          return 'Default';
        case 'LOADER':
          return 'Loader';
        case 'DRIVER':
          return 'Driver';
        case 'OPERATOR':
          return 'Operator';
        default:
          return '';
      }
    },
  },
  watch: {
    section(newSection) {
      const { employeeId } = this.$route.params;
      this.$router.push(`/admin/employees/${employeeId}/${newSection}`);
    },
    detailedInfo() {
      const { section } = this.$route.params;
      this.section = isUndefined(section) ? this.section : section;
    },
  },
};
</script>
<style>

</style>




// WEBPACK FOOTER //
// src/views/pages/admin/employees/Detail.vue